import { Box, Text } from '@chakra-ui/react';

interface Props {
  label: string;
  onClick: (name: string) => void;
  selected?: boolean;
}

export const TopicBadge = ({ label, selected, onClick }: Props) => {
  return (
    <Box
      px={6}
      py={4}
      h={'34px'}
      minW="fit-content"
      display="flex"
      justifyContent="center"
      alignItems="center"
      borderRadius="100px"
      border="solid 1px #261F56"
      userSelect="none"
      backgroundColor={selected ? '#261F56' : '#FFF'}
      cursor={selected ? 'initial' : 'pointer'}
      onClick={() => onClick(label)}
    >
      <Text
        color={selected ? '#FFF' : 'purple.500'}
        variant={'text-xs/lineHeight-4/font-semibold'}
        fontSize={'12px'}
        fontWeight="600"
        whiteSpace="nowrap"
      >
        {label}
      </Text>
    </Box>
  );
};
